var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Users',{attrs:{"users":_vm.users,"user-roles":_vm.userRoles,"password-min-length":_vm.passwordMinLength,"user-added":_vm.userAdded},on:{"addUser":_vm.addNewUser}})}
var staticRenderFns = []

export { render, staticRenderFns }